import React from 'react';
import {Flex} from '/app/src/component';

export default class NumberInput extends React.Component {
    render() {
        let {placeholder, value, onChange, name, ...rest} = this.props
        return(
            <Flex column shrink={0}  {...rest}>
                <input
                    type="number"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    name={name}
                    style={{width: '100%'}}
                    />
            </Flex>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/Forms/NumberInput/index.js